import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "hide-in-print" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-drucken mr-2",
  "aria-hidden": "true"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      type: "button",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openPrintDialog())),
      class: "btn d-flex align-items-center text-brand1"
    }, [
      _hoisted_2,
      _createTextVNode(" " + _toDisplayString(_ctx.$t(_ctx.i18nMessage)), 1)
    ])
  ]))
}